import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f2bf89c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "LIFT 2.0", -1));
const _hoisted_3 = {
    key: 0,
    class: "noneFound ml-4"
};
const _hoisted_4 = { key: 2 };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, " This summary shows the key LIFT 2.0 milestone dates and deliverables for this citizen. ", -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "sectionHeader" }, "Onboarding", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "sectionHeader" }, "TB Testing", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "sectionHeader" }, "Birth Records", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "sectionHeader" }, "Social Security", -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "sectionHeader" }, "State ID", -1));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "sectionHeader" }, "Program Exit", -1));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "pt-5 mt-5" }, null, -1));
import { useAsync } from "@/composables/useAsync";
import { isFeatureEnabled, sessionState } from "@/core/session";
import { formatDateShort, formatTimeDifference } from "@/core/utils";
import { computed, onMounted } from "vue";
import { apiLift20 } from "../api";
import ProgressIndicator from "./ProgressIndicator.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitizenLift20SummaryPanel',
    props: {
        citizen: {}
    },
    setup(__props) {
        const props = __props;
        const summary = useAsync();
        onMounted(() => {
            if (!sessionState.session)
                return; // We should only be here if we're logged-in
            if (!props.citizen.liftEnrolledAt)
                return;
            summary.fetch(apiLift20.getCitizenSummary(props.citizen.id));
        });
        const dateAndDelayLabel = (previous, current) => {
            const dateLabel = current ? formatDateShort(current)
                : (previous ? 'In Progress' : 'Pending');
            if (!previous)
                return dateLabel;
            const delayLabel = current ? formatTimeDifference(previous, current) : formatTimeDifference(previous, new Date().getTime());
            return `${dateLabel} (${delayLabel})`;
        };
        const stateIdOrderDeadlineStartDate = computed(() => {
            if (!summary.data)
                return undefined;
            // Deadline for ordering start ID begins when both birth records and social security card have been obtained
            let brReceived = summary.data.birthRecords.received;
            let ssReceived = summary.data.socialSecurity.received;
            // If the citizen already had some records, we may have been able to enter them into HMIS without ever ordering them
            if (!brReceived) {
                brReceived = summary.data.birthRecords.enteredIntoHmis;
            }
            if (!ssReceived) {
                ssReceived = summary.data.socialSecurity.enteredIntoHmis;
            }
            if (!(brReceived && ssReceived))
                return undefined;
            return brReceived > ssReceived ? brReceived : ssReceived;
        });
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            return (_unref(isFeatureEnabled)('LIFT_2_0'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    (!_ctx.citizen.liftEnrolledAt)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " This citizen is not enrolled in the LIFT 2.0 program "))
                        : (_unref(summary).status == 'loading')
                            ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 1 }))
                            : (_unref(summary).status == 'ready')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _hoisted_5,
                                    _hoisted_6,
                                    _hoisted_7,
                                    _createVNode(ProgressIndicator, {
                                        startDate: _unref(summary).data.onboarding.conducted,
                                        deliverables: [
                                            { label: 'Enter Into HMIS', deadlineHours: 48, message: 'Due #DEADLINE# after first contact', completedDate: _unref(summary).data.onboarding.enteredIntoHmis }
                                        ]
                                    }, null, 8, ["startDate", "deliverables"]),
                                    _hoisted_8,
                                    _createVNode(ProgressIndicator, {
                                        startDate: _unref(summary).data.onboarding.conducted,
                                        deliverables: [
                                            { label: 'Conduct Test', message: 'Due #DEADLINE# after first contact', deadlineDays: 14, completedDate: _unref(summary).data.tbTesting.conducted },
                                            { label: 'Enter Into HMIS', message: 'Due #DEADLINE# after test results received', deadlineHours: 48, completedDate: _unref(summary).data.tbTesting.enteredIntoHmis }
                                        ]
                                    }, null, 8, ["startDate", "deliverables"]),
                                    _hoisted_9,
                                    _createVNode(ProgressIndicator, {
                                        startDate: _unref(summary).data.onboarding.conducted,
                                        deliverables: [
                                            { label: 'Submit To State', message: 'Due #DEADLINE# after first contact', deadlineDays: 7, completedDate: _unref(summary).data.birthRecords.submitted },
                                            { label: 'Receive Records From State', message: 'Delay dependant on state records office', completedDate: _unref(summary).data.birthRecords.received },
                                            { label: 'Enter Into HMIS', message: 'Due #DEADLINE# after records received', deadlineHours: 48, completedDate: _unref(summary).data.birthRecords.enteredIntoHmis }
                                        ]
                                    }, null, 8, ["startDate", "deliverables"]),
                                    _hoisted_10,
                                    _createVNode(ProgressIndicator, {
                                        startDate: _unref(summary).data.onboarding.conducted,
                                        deliverables: [
                                            { label: 'Submit To State', message: 'Due #DEADLINE# after first contact', deadlineDays: 21, completedDate: _unref(summary).data.socialSecurity.submitted },
                                            { label: 'Receive Records From State', message: 'Delay dependant on Social Security Administration', completedDate: _unref(summary).data.socialSecurity.received },
                                            { label: 'Enter Into HMIS', message: 'Due #DEADLINE# after records received', deadlineHours: 48, completedDate: _unref(summary).data.socialSecurity.enteredIntoHmis }
                                        ]
                                    }, null, 8, ["startDate", "deliverables"]),
                                    _hoisted_11,
                                    _createVNode(ProgressIndicator, {
                                        startDate: stateIdOrderDeadlineStartDate.value,
                                        deliverables: [
                                            { label: 'Submit To State', message: 'Due #DEADLINE# after after birth record and SS card received', deadlineDays: 7, completedDate: _unref(summary).data.socialSecurity.submitted },
                                            { label: 'Receive Records From State', message: 'Delay dependant on state office', completedDate: _unref(summary).data.socialSecurity.received },
                                            { label: 'Enter Into HMIS', message: 'Due #DEADLINE# after records received', deadlineHours: 48, completedDate: _unref(summary).data.socialSecurity.enteredIntoHmis }
                                        ]
                                    }, null, 8, ["startDate", "deliverables"]),
                                    _hoisted_12,
                                    _createVNode(ProgressIndicator, {
                                        startDate: _unref(summary).data.onboarding.conducted,
                                        deliverables: [
                                            { label: 'Achieve Document Readiness', message: 'Due #DEADLINE# after first contact', deadlineDays: 60, completedDate: _unref(summary).data.programExit.documentReady },
                                            { label: 'Enter Into HMIS', message: 'Due #DEADLINE# after all records received', deadlineHours: 48, completedDate: _unref(summary).data.programExit.enteredIntoHmis }
                                        ]
                                    }, null, 8, ["startDate", "deliverables"]),
                                    _hoisted_13
                                ]))
                                : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
